import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Typography,
  Divider,
  useTheme,
  Chip,
  useMediaQuery,
  Badge,
} from '@mui/material';
import {
  Dashboard,
  Restaurant,
  Store,
  MenuBook,
  LocalShipping,
  Event,
  TableRestaurant,
  Analytics,
  Settings,
  Home,
  Person,
  Token,
  DynamicForm,
  // Payment, // Commented out - Payment tab is hidden
  QrCode,
  Info,
  ConnectWithoutContact,
  ExpandMore,
  ExpandLess,
  BarChart,
  Receipt,
  ManageAccounts,
  Print,
  Fastfood,
  Summarize,Timeline,
  TrendingUp,
  Feedback
} from '@mui/icons-material';
import { useRestaurant } from '../../contexts/RestaurantContext';
import { getAdminTabs } from '../../services/adminUserService';
import { clear_fcm_token } from '../../services/notificationService';

const Sidebar = ({ open, onClose, isMobile, rootNotificationCount, setRootNotificationCount, rootDeliveryNotificationCount, rootTakeawayNotificationCount, rootCateringNotificationCount, setRootDeliveryNotificationCount, setRootTakeawayNotificationCount, setRootCateringNotificationCount, rootReservationNotificationCount, setRootReservationNotificationCount,notificationReload,setNotificationReload }) => {

  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

  const { notificationCount, reservationPendingCount, deliveryNotificationCount, takeawayNotificationCount, cateringNotificationCount, setAdminLogin, setNotificationCount } = useRestaurant();
  const [totalOrderCount, setTotalOrdersCount] = useState(0);
  const [reportsOpen, setReportsOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [adminTabs, setAdminTabs] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [tabsLength,setTabsLength] = useState(0);

  useEffect(() => {
    async function fetchAdminTabs() {
      try {
        const response = await getAdminTabs();
        setAdminTabs(response.tabs);
        // setTabsLength(response.tabs.length)
        // console.log("Response Tabs => ", response.tabs);
      } catch (error) {
        // console.error("Error Occured", error);
      } finally {
        setIsLoading(false);
      }
    }
    fetchAdminTabs();
    // console.log("Admin Login")
    // setAdminLogin(true)
    // setNotificationCount(0)
  }, []);

  useEffect(() => {
    setRootNotificationCount(notificationCount);
    let ordersCount = deliveryNotificationCount + takeawayNotificationCount
    setRootDeliveryNotificationCount(deliveryNotificationCount)
    setTotalOrdersCount(ordersCount);
    setRootCateringNotificationCount(cateringNotificationCount)
    // console.log("Yes It is Called => ", rootDeliveryNotificationCount)
    // console.log(deliveryNotificationCount)
  }, [notificationCount, deliveryNotificationCount, takeawayNotificationCount, cateringNotificationCount,notificationReload]);

  // useEffect(() => {
  //   // Check if reports section should be open
  //   if (location.pathname.includes('/admin/sales-report') ||
  //     location.pathname.includes('/admin/orders-report')) {
  //     setReportsOpen(true);
  //   }

  //   // Check if settings section should be open based on current path
  //   const settingsPaths = [
  //     '/admin/outlets',
  //     '/admin/config',
  //     '/admin/social-links',
  //     '/admin/user-settings',
  //     '/admin/users',
  //     '/admin/tokens',
  //     '/admin/printer-settings',
  //     '/admin/testimonials'
  //   ];

  //   if (settingsPaths.some(path => location.pathname.startsWith(path))) {
  //     setSettingsOpen(true);
  //   }
  // }, [location.pathname]);


  useEffect(() => {
  // Check if reports section should be open
  const isReportsPath = location.pathname.includes('/admin/sales-report') ||
    location.pathname.includes('/admin/orders-report') ||
    location.pathname.includes('/admin/performance-report') ||
    location.pathname.includes('/admin/gst-report') ||
    location.pathname.includes('/admin/peak-report') ||
    location.pathname.includes('/admin/peakorders-report');
  
  // Check if settings section should be open based on current path
  const settingsPaths = [
    '/admin/outlets',
    '/admin/config',
    '/admin/social-links',
    '/admin/user-settings',
    '/admin/users',
    '/admin/tokens',
    '/admin/printer-settings',
    '/admin/testimonials'
  ];
  const isSettingsPath = settingsPaths.some(path => location.pathname.startsWith(path));

  // Only update if the user is on a relevant path, but don't force close if already open
  // This prevents overriding user's manual toggle
  if (isReportsPath && !reportsOpen) {
    setReportsOpen(true);
  }
  
  if (isSettingsPath && !settingsOpen) {
    setSettingsOpen(true);
  }
  
  // Optional: Auto-close sections when navigating away
  // if (!isReportsPath && !location.pathname.includes('/admin/reports')) {
  //   setReportsOpen(false);
  // }
  
  // if (!isSettingsPath && !location.pathname.includes('/admin/settings')) {
  //   setSettingsOpen(false);
  // }
}, [location.pathname, reportsOpen, settingsOpen]);


  const handleNavigation = async (path) => {
    if (path === '/' ||
      (path.startsWith('/') && !path.startsWith('/admin'))) {
      const confirmed = window.confirm(
        'You are about to navigate to the public website. This will log you out of the admin panel. Continue?'
      );

      if (!confirmed) {
        return;
      }
      localStorage.setItem("Side Bar ", "YES");
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      await clear_fcm_token()
      localStorage.removeItem('tk_id');
      localStorage.removeItem('user_id');
    }

    navigate(path);
    if (isMobile) {
      onClose();
    }
  };

  const toggleReports = () => {
    setReportsOpen(!reportsOpen);
  };

  const toggleSettings = () => {
    setSettingsOpen(!settingsOpen);
  };

  // Define all menu items (excluding settings items that will be submenus)
  const allMenuItems = [
    {
      title: 'Home Page',
      icon: <Home sx={{ fontSize: '1.4rem' }} />,
      path: '/',
      description: 'Public Website',
      isPublic: true,
      tabKey: null, // Always visible
    },
    {
      title: 'Dashboard',
      icon: <Dashboard sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/dashboard',
      description: 'Overview & Analytics',
      tabKey: null,
    },
    {
      title: 'Delivery',
      icon: <LocalShipping sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/delivery',
      description: 'Orders & Takeaway',
      badge: totalOrderCount > 0 ? totalOrderCount : undefined,
      tabKey: 'delivery',
    },
    {
      title: 'Reservation',
      icon: <TableRestaurant sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/tables',
      description: 'Reservations & Orders',
      badge: reservationPendingCount > 0 ? reservationPendingCount : undefined,
      tabKey: 'reservations',
    },
     {
      title: 'Table Orders',
      icon: <TableRestaurant sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/table-addition',
      description: 'Tables & Dine In',
      tabKey: 'table_orders',
    },
    {
      title: 'Catering Info',
      icon: <Info sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/info',
      description: 'Quotations and Invoices',
      tabKey: 'catering_info',
    },
    {
      title: 'Catering Config',
      icon: <Event sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/catering',
      description: 'Event Services',
      badge: rootCateringNotificationCount > 0 ? rootCateringNotificationCount : undefined,
      tabKey: 'catering_config',
    },
    {
      title: 'Notifications',
      icon: <DynamicForm sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/notifications',
      description: 'Notification Management',
      badge: rootNotificationCount > 0 ? rootNotificationCount : undefined,
      tabKey: 'notifications',
    },
    {
      title: 'Menu',
      icon: <MenuBook sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/menu',
      description: 'Food & Categories',
      tabKey: 'menu',
    },

   
    // {
    //   title: 'Table Orders',
    //   icon: <QrCode sx={{ fontSize: '1.4rem' }} />,
    //   path: '/admin/table-orders',
    //   description: 'QR Code Table Orders',
    //   tabKey: 'table_orders',
    // },
    // {
    //   title: 'Analytics',
    //   icon: <Analytics />,
    //   path: '/admin/analytics',
    //   description: 'Reports & Insights',
    //   tabKey: 'analytics',
    // },
  ];

  // Settings sub-items
  const settingsItems = [
    {
      title: 'Outlets',
      icon: <Store sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/outlets',
      description: 'Manage Locations',
      tabKey: 'outlets',
    },
    {
      title: 'Configuration',
      icon: <Settings sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/config',
      description: 'Restaurant Settings',
      tabKey: 'configuration',
    },
    {
      title: 'Social Links',
      icon: <ConnectWithoutContact sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/social-links',
      description: 'Social Media Configuration',
      tabKey: 'social_links',
    },
    {
      title: 'User Settings',
      icon: <ManageAccounts sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/user-settings',
      description: 'User Settings',
      tabKey: 'user_settings',
    },
    {
      title: 'Users',
      icon: <Person sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/users',
      description: 'User Details',
      tabKey: 'users',
    },
    {
      title: 'Token Settings',
      icon: <Token sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/tokens',
      description: 'Token Settings',
      tabKey: 'token_management',
    },
    {
      title: 'Printers',
      icon: <Print sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/printer-settings',
      description: 'Printer Settings',
      tabKey: 'printers',
    },
    {
      title: 'Testimonials',
      icon: <DynamicForm sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/testimonials',
      description: 'Testimonials Settings',
      tabKey: 'testimonials',
    },
    {
      title: 'Feedback',
      icon: <Feedback sx={{ fontSize: '1.4rem' }} />,
      path: '/admin/feedback',
      description: 'Customer Feedbacks',
      tabKey: 'feedback',
    },
  
  ];

  // Report sub-items
  const reportItems = [
    {
      title: 'Sales Report',
      icon: <BarChart sx={{ fontSize: '1.4rem', ml: 2 }} />,
      path: '/admin/sales-report',
      tabKey: 'reports',
    },
    {
      title: 'Orders Report',
      icon: <Receipt sx={{ fontSize: '1.4rem', ml: 2 }} />,
      path: '/admin/orders-report',
      tabKey: 'reports',
    },
     {
      title: 'Menu Perfomance Report',
      icon: <Fastfood sx={{ fontSize: '1.4rem', ml: 2 }} />,
      path: '/admin/performance-report',
      tabKey: 'reports',
    },
     {
      title: 'GST Report',
      icon: <Summarize sx={{ fontSize: '1.4rem', ml: 2 }} />,
      path: '/admin/gst-report',
      tabKey: 'reports',
    },
    {
      title: 'Peak Hours Items Report',
      icon: <Timeline sx={{ fontSize: '1.4rem', ml: 2 }} />,
      path: '/admin/peak-report',
      tabKey: 'reports',
    },
    {
      title: 'Peak Hours Orders Report',
      icon: <TrendingUp sx={{ fontSize: '1.4rem', ml: 2 }} />,
      path: '/admin/peakorders-report',
      tabKey: 'reports',
    },
  ];

  // Filter menu items based on adminTabs
  const getFilteredMenuItems = () => {
    if (isLoading) {
      // Show all items or a loading state while fetching
      return allMenuItems;
    }


     let check  =  allMenuItems.filter(item => {
      // Always show Home Page and items without tabKey
      if (item.tabKey === null || item.isPublic) {
        return true;
      }

      // Check if the item should be shown based on adminTabs
      return adminTabs[item.tabKey] === true;
    });

    // console.log("Tabs => ",check)
    return allMenuItems.filter(item => {
      // Always show Home Page and items without tabKey
      if (item.tabKey === null || item.isPublic) {
        return true;
      }

      // Check if the item should be shown based on adminTabs
      return adminTabs[item.tabKey] === true;
    });
  };

  // Filter settings items
  const getFilteredSettingsItems = () => {
    if (isLoading) {
      return settingsItems;
    }

    return settingsItems.filter(item => {
      return adminTabs[item.tabKey] === true;
    });
  };

  // Filter report items
  const getFilteredReportItems = () => {
    if (isLoading) {
      return reportItems;
    }

    // Check if reports are enabled
    if (adminTabs.reports === true) {
      return reportItems;
    }

    return [];
  };

  const filteredMenuItems = getFilteredMenuItems();
  const filteredSettingsItems = getFilteredSettingsItems();
  const filteredReportItems = getFilteredReportItems();
  const isReportsEnabled = adminTabs.reports === true;
  const isSettingsEnabled = filteredSettingsItems.length > 0;

  // Check if any settings item is active
  const isAnySettingsActive = filteredSettingsItems.some(item =>
    location.pathname.startsWith(item.path)
  );

  // Split menu items for different sections
  const firstSectionItems = filteredMenuItems.slice(0, 8);
  const secondSectionItems = filteredMenuItems.slice(8);

  const sidebarContent = (
    <Box
      sx={{
        width: open ? 280 : 80,
        height: '100%',
        bgcolor: 'background.paper',
        borderRight: '1px solid',
        borderColor: 'divider',
        backgroundImage: 'none',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Navigation Menu */}
      <Box sx={{
        flexGrow: 1, py: { xs: 1, sm: 2 },
        overflow: 'auto',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        '-ms-overflow-style': 'none',
        'scrollbar-width': 'none',
      }}>
        <List sx={{ px: { xs: 0.5, sm: 1 } }}>
          {firstSectionItems.map((item) => {
            let isActive = location.pathname.startsWith(item.path);

            if (location.pathname.startsWith("/admin/quotation") && item.title === "Catering Info") {
              isActive = true;
            }

            if (location.pathname.startsWith("/admin/invoice-catering") && item.title === "Catering Info") {
              isActive = true;
            }

            const isPublicPage = item.isPublic;

            return (
              <ListItem key={item.path} disablePadding sx={{ mb: { xs: 0.25, sm: 0.5 } }}>
                <ListItemButton
                  onClick={() => handleNavigation(item.path)}
                  sx={{
                    borderRadius: 2,
                    mx: { xs: 0.5, sm: 1 },
                    ml: { md: '2px' },
                    minHeight: { xs: 48, sm: 56 },
                    bgcolor: isActive ? 'primary.main' : 'transparent',
                    color: isActive ? 'white' : 'text.primary',
                    transition: 'all 0.2s ease-in-out',
                    border: isPublicPage ? '1px solid' : 'none',
                    borderColor: isPublicPage ? 'warning.main' : 'transparent',
                    px: { xs: 1, sm: 2 },
                    py: { xs: 1, sm: 1.5 },
                    '&:hover': {
                      bgcolor: isActive ? 'primary.dark' : (isPublicPage ? 'warning.50' : 'action.hover'),
                      transform: 'translateX(4px)',
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      color: 'inherit',
                      minWidth: open ? 40 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>

                  {open && (
                    <ListItemText
                      primary={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography variant="body1" fontWeight="500">
                            {item.title}
                          </Typography>
                          {item.badge && (
                            <Chip
                              label={item.badge}
                              size="small"
                              color="secondary"
                              sx={{ height: 20, fontSize: '0.9rem' }}
                            />
                          )}
                          {isPublicPage && (
                            <Chip
                              label="Public"
                              size="small"
                              color="warning"
                              sx={{ height: 20, fontSize: '0.9rem' }}
                            />
                          )}
                        </Box>
                      }
                      secondary={
                        <Typography variant="caption" sx={{ opacity: 0.8 }}>
                          {item.description}
                        </Typography>
                      }
                      sx={{ m: 0 }}
                    />
                  )}
                </ListItemButton>
              </ListItem>
            );
          })}


          {/* Reports Section - Only show if reports are enabled */}
          {isReportsEnabled && (
            <>
              <ListItem disablePadding sx={{ mb: { xs: 0.25, sm: 0.5 } }}>
                <ListItemButton
                  onClick={toggleReports}
                  sx={{
                    borderRadius: 2,
                    mx: { xs: 0.5, sm: 1 },
                    ml: { md: '2px' },
                    minHeight: { xs: 48, sm: 56 },
                    bgcolor: location.pathname.includes('/admin/sales-report') ||
                      location.pathname.includes('/admin/orders-report') || location.pathname.includes('/admin/performance-report')  || location.pathname.includes('/admin/gst-report')  || location.pathname.includes('/admin/peak-report') || location.pathname.includes('/admin/peakorders-report') ? 'primary.main' : 'transparent',
                    color: location.pathname.includes('/admin/sales-report') ||
                      location.pathname.includes('/admin/orders-report')  || location.pathname.includes('/admin/performance-report')  || location.pathname.includes('/admin/gst-report') || location.pathname.includes('/admin/peak-report') || location.pathname.includes('/admin/peakorders-report')? 'white' : 'text.primary',
                    transition: 'all 0.2s ease-in-out',
                    px: { xs: 1, sm: 2 },
                    py: { xs: 1, sm: 1.5 },
                    '&:hover': {
                      bgcolor: location.pathname.includes('/admin/sales-report') ||
                        location.pathname.includes('/admin/orders-report')|| location.pathname.includes('/admin/performance-report')  || location.pathname.includes('/admin/gst-report')  || location.pathname.includes('/admin/peak-report') || location.pathname.includes('/admin/peakorders-report') ? 'primary.dark' : 'action.hover',
                      transform: 'translateX(4px)',
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      color: 'inherit',
                      minWidth: open ? 40 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <BarChart sx={{ fontSize: '1.4rem' }} />
                  </ListItemIcon>

                  {open && (
                    <ListItemText
                      primary={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'space-between', width: '100%' }}>
                          <Typography variant="body1" fontWeight="500">
                            Reports
                          </Typography>
                          {reportsOpen ? <ExpandLess /> : <ExpandMore />}
                        </Box>
                      }
                      secondary={
                        <Typography variant="caption" sx={{ opacity: 0.8 }}>
                          Sales and Orders Report
                        </Typography>
                      }
                      sx={{ m: 0 }}
                    />
                  )}
                </ListItemButton>
              </ListItem>

              {/* Report Sub-items */}
              {open && reportsOpen && (
                <List sx={{ pl: { xs: 2, sm: 3 } }}>
                  {filteredReportItems.map((item) => {
                    const isActive = location.pathname === item.path;

                    return (
                      <ListItem key={item.path} disablePadding sx={{ mb: { xs: 0.25, sm: 0.5 } }}>
                        <ListItemButton
                          onClick={() => handleNavigation(item.path)}
                          sx={{
                            borderRadius: 2,
                            mx: { xs: 0.25, sm: 0.5 },
                            minHeight: { xs: 44, sm: 48 },
                            bgcolor: isActive ? 'primary.light' : 'transparent',
                            color: isActive ? 'primary.contrastText' : 'text.primary',
                            transition: 'all 0.2s ease-in-out',
                            pl: { xs: 2, sm: 3 },
                            '&:hover': {
                              bgcolor: isActive ? 'primary.main' : 'action.hover',
                              transform: 'translateX(2px)',
                            },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              color: 'inherit',
                              minWidth: 30,
                              justifyContent: 'center',
                              mr:1
                            }}
                          >
                            {item.icon}
                          </ListItemIcon>
                          <ListItemText
                            primary={
                              <Typography variant="body2" fontWeight={isActive ? "600" : "400"}>
                                {item.title}
                              </Typography>
                            }
                            secondary={
                              <Typography variant="caption" sx={{ opacity: 0.8 }}>
                                {item.description}
                              </Typography>
                            }
                            sx={{ m: 0 }}
                          />
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                </List>
              )}
            </>
          )}

          {/* Settings Section */}
          {isSettingsEnabled && (
            <>
              <ListItem disablePadding sx={{ mb: { xs: 0.25, sm: 0.5 } }}>
                <ListItemButton
                  onClick={toggleSettings}
                  sx={{
                    borderRadius: 2,
                    mx: { xs: 0.5, sm: 1 },
                    ml: { md: '2px' },
                    minHeight: { xs: 48, sm: 56 },
                    bgcolor: isAnySettingsActive ? 'primary.main' : 'transparent',
                    color: isAnySettingsActive ? 'white' : 'text.primary',
                    transition: 'all 0.2s ease-in-out',
                    px: { xs: 1, sm: 2 },
                    py: { xs: 1, sm: 1.5 },
                    '&:hover': {
                      bgcolor: isAnySettingsActive ? 'primary.dark' : 'action.hover',
                      transform: 'translateX(4px)',
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      color: 'inherit',
                      minWidth: open ? 40 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <Settings sx={{ fontSize: '1.4rem' }} />
                  </ListItemIcon>

                  {open && (
                    <ListItemText
                      primary={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'space-between', width: '100%' }}>
                          <Typography variant="body1" fontWeight="500">
                            Settings
                          </Typography>
                          {settingsOpen ? <ExpandLess /> : <ExpandMore />}
                        </Box>
                      }
                      secondary={
                        <Typography variant="caption" sx={{ opacity: 0.8 }}>
                          System Configuration
                        </Typography>
                      }
                      sx={{ m: 0 }}
                    />
                  )}
                </ListItemButton>
              </ListItem>

              {/* Settings Sub-items */}
              {open && settingsOpen && (
                <List sx={{ pl: { xs: 2, sm: 3 } }}>
                  {filteredSettingsItems.map((item) => {
                    const isActive = location.pathname.startsWith(item.path);

                    return (
                      <ListItem key={item.path} disablePadding sx={{ mb: { xs: 0.25, sm: 0.5 } }}>
                        <ListItemButton
                          onClick={() => handleNavigation(item.path)}
                          sx={{
                            borderRadius: 2,
                            mx: { xs: 0.25, sm: 0.5 },
                            minHeight: { xs: 44, sm: 48 },
                            bgcolor: isActive ? 'primary.light' : 'transparent',
                            color: isActive ? 'primary.contrastText' : 'text.primary',
                            transition: 'all 0.2s ease-in-out',
                            pl: { xs: 2, sm: 3 },
                            '&:hover': {
                              bgcolor: isActive ? 'primary.main' : 'action.hover',
                              transform: 'translateX(2px)',
                            },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              color: 'inherit',
                              minWidth: 30,
                              justifyContent: 'center',
                            }}
                          >
                            {item.icon}
                          </ListItemIcon>
                          <ListItemText
                            primary={
                              <Typography variant="body2" fontWeight={isActive ? "600" : "400"}>
                                {item.title}
                              </Typography>
                            }
                            secondary={
                              <Typography variant="caption" sx={{ opacity: 0.8 }}>
                                {item.description}
                              </Typography>
                            }
                            sx={{ m: 0 }}
                          />
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                </List>
              )}
            </>
          )}



          {/* Remaining menu items */}
          {secondSectionItems.map((item) => {
            const isActive = location.pathname.startsWith(item.path);
            const isPublicPage = item.isPublic;

            return (
              <ListItem key={item.path} disablePadding sx={{ mb: { xs: 0.25, sm: 0.5 } }}>
                <ListItemButton
                  onClick={() => handleNavigation(item.path)}
                  sx={{
                    borderRadius: 2,
                    mx: { xs: 0.5, sm: 1 },
                    ml: { md: '2px' },
                    minHeight: { xs: 48, sm: 56 },
                    bgcolor: isActive ? 'primary.main' : 'transparent',
                    color: isActive ? 'white' : 'text.primary',
                    transition: 'all 0.2s ease-in-out',
                    border: isPublicPage ? '1px solid' : 'none',
                    borderColor: isPublicPage ? 'warning.main' : 'transparent',
                    px: { xs: 1, sm: 2 },
                    py: { xs: 1, sm: 1.5 },
                    '&:hover': {
                      bgcolor: isActive ? 'primary.dark' : (isPublicPage ? 'warning.50' : 'action.hover'),
                      transform: 'translateX(4px)',
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      color: 'inherit',
                      minWidth: open ? 40 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>

                  {open && (
                    <ListItemText
                      primary={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography variant="body1" fontWeight="500">
                            {item.title}
                          </Typography>
                          {item.badge && (
                            <Chip
                              label={item.badge}
                              size="small"
                              color="secondary"
                              sx={{ height: 20, fontSize: '0.9rem' }}
                            />
                          )}
                          {isPublicPage && (
                            <Chip
                              label="Public"
                              size="small"
                              color="warning"
                              sx={{ height: 20, fontSize: '0.9rem' }}
                            />
                          )}
                        </Box>
                      }
                      secondary={
                        <Typography variant="caption" sx={{ opacity: 0.8 }}>
                          {item.description}
                        </Typography>
                      }
                      sx={{ m: 0 }}
                    />
                  )}
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>

        {open && (
          <Box sx={{ px: 2, mt: 2 }}>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="caption" color="text.secondary" sx={{ px: 1 }}>
              Version - 1.0.1
            </Typography>
          </Box>
        )}
      </Box>

      {/* Footer */}
      {open && (
        <Box sx={{ p: 2, borderTop: '1px solid', borderColor: 'divider' }}>
          <Typography variant="caption" color="text.secondary" align="center" display="block">
            Restaurant Management v1.0
          </Typography>
        </Box>
      )}
    </Box>
  );

  if (isMobile) {
    return (
      <Drawer
        variant="temporary"
        open={open}
        onClose={onClose}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          '& .MuiDrawer-paper': {
            width: 280,
            boxSizing: 'border-box',
          },
        }}
      >
        {sidebarContent}
      </Drawer>
    );
  }

  return (
    <Drawer
      variant="permanent"
      sx={{
        '& .MuiDrawer-paper': {
          mt: '65px',
          borderRadius: 0,
          width: open ? 280 : 80,
          boxSizing: 'border-box',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
          overflowX: 'hidden',
        },
      }}
    >
      {sidebarContent}
    </Drawer>
  );
};

export default Sidebar;